import { Select, SelectProps, notification } from "antd";
import { useEffect, useState } from "react";
import APIClient from "../api/api";
import { Domain } from "../api/models";

export interface Props {
    onChange: (tags: string[]) => void;
    placeholder: string;
    disabled?: boolean;
    reload?: boolean;
    allowNew?: boolean;
}

const TagSelect = (props: Props) => {
    const [tags, setTags] = useState<SelectProps["options"]>();
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        loadTags();
    }, [props.reload]);

    function onChange(values: any) {
        props.onChange(values);
    }

    async function loadTags() {
        try {
            const resp = await APIClient.listTags();
            setTags(resp.tags.map(tag => {
                return {value: tag, label: tag};
            }));
        }
        catch(e) {
            notification.error({message: 'Failed to load tags.'});
        }
    }

    return (
        <Select mode={props.allowNew ? 'tags' : 'multiple'} placeholder={props.placeholder} allowClear showSearch style={{width: '100%'}} loading={saving} disabled={saving || props.disabled} options={tags} onChange={onChange}/>
    );
};

export default TagSelect;
